import { CartItemV2 } from "@onair/repositories";
import { create } from "zustand";

export interface CartStore {
	total: number;
	items: CartItemV2[];
	recentAddedItem: string[];
}

export const INITIAL_STATE = {
	total: 0,
	items: [],
	recentAddedItem: [],
};

export const useCartStore = create<CartStore>(() => ({
	...(INITIAL_STATE as CartStore),
}));
